import React, {useEffect, useRef} from 'react';
import styled from 'styled-components';
import {DarkSpiral, LightSpiral} from '../../data/id-mirror-data';
import {useIdMirrorTheme} from '../../hooks/use-id-mirror-theme';

const bgStyles = `
  position: absolute;
  inset: 0;
  background:
    linear-gradient(to bottom, var(--linear-start), var(--linear-middle), var(--linear-end)),
    var(--spiral-image),
    radial-gradient(var(--radial-start), var(--radial-end));
  background-size: 100% 70%, cover, 100% 100%;
  background-position: bottom, center, center;
  background-repeat: no-repeat;
  will-change: opacity;
`;

const LightLayer = styled.div`
  ${bgStyles}
  --radial-start: #00437a;
  --radial-end: #00b0f0;
  --linear-start: rgba(0, 30, 80, 0) 0%;
  --linear-middle: rgba(0, 30, 80, 0.1) 15%;
  --linear-end: rgba(0, 88, 160, 1) 54%;
  --spiral-image: url(${LightSpiral});
`;

const DarkLayer = styled.div`
  ${bgStyles}
  --radial-start: #00437a;
  --radial-end: #001e50;
  --linear-start: rgba(0, 30, 80, 0) 0%;
  --linear-middle: rgba(0, 30, 80, 0.6) 19%;
  --linear-end: rgba(0, 30, 80, 1) 31%;
  --spiral-image: url(${DarkSpiral});
`;

const Wrapper = styled.div`
  position: relative;
  min-width: 100%;
  overflow: hidden;
`;

export const Background = ({children}: React.PropsWithChildren) => {
  const {theme, registerRefs} = useIdMirrorTheme();
  const lightRef = useRef<HTMLDivElement>(null);
  const darkRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    registerRefs({lightLayer: lightRef.current, darkLayer: darkRef.current});
    return () => {
      registerRefs({lightLayer: null, darkLayer: null});
    }; // cuando el componente se desmonta -> limpiar refs
  }, []);

  return (
    <Wrapper className="id-mirror-background-wrapper">
      <LightLayer
        ref={lightRef}
        style={{opacity: theme === 'light' ? 1 : 0}}
        className="background-layer-light"
      />
      <DarkLayer
        ref={darkRef}
        style={{opacity: theme === 'dark' ? 1 : 0}}
        className="background-layer-dark"
      />
      <div className="id-mirror-content-wrapper" style={{position: 'relative'}}>
        {children}
      </div>
    </Wrapper>
  );
};
